import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {injectIntl, FormattedMessage} from 'react-intl';

import {AVAILABLE_LANGUAGES} from 'config';
import {changeLanguage} from 'modules/language';

import {MenuItem, DropdownButton} from 'react-bootstrap';

import 'style/containers/ui/select/language-select.scss';

const iconUrl = {
    es: require('img/icon-lang-es.png'),
    en: require('img/icon-lang-en.png')
};

/**
 * Render a MenuItem.
 * @param {String} code The code for the language.
 * @param {String} text The text for the language.
 * @return {Component} A MenuItem instance
 */
const _renderMenuItem = (code, text) => (
    <MenuItem eventKey={code} key={code}>
        <img alt={code} src={iconUrl[code]} className="flag"/>
        <FormattedMessage id={text}/>
    </MenuItem>
);
/**
 * Render the full menu.
 * @return {Array} An array of MenuItem instance
 */
const _renderMenu = () => AVAILABLE_LANGUAGES.map(code => _renderMenuItem(code, `title.lang.${code}`));
/**
 * Render the title.
 * @param {String} lang The current selected language.
 * @return {Component} A span with the title inside.
 */
const _renderTitle = lang => (
    <span>
        <img alt={lang} src={iconUrl[lang]} className="flag"/>
        <FormattedMessage id={`title.lang.${lang}`}/>
    </span>
);


/**
 * Component to draw the language selector dropdown
 */
class LanguageSelect extends Component {
    static propTypes = {
        className: PropTypes.string, // className to pass to container component,
        lang:      PropTypes.string // The initial selected language
    };

    static defaultProps = {
        lang:      '',
        className: ''
    };

    /**
     * Set the handlers
     */
    componentWillMount() {

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * It's fired when the user changes the language in the dropdown so call to the action to do this.
     * @param {String} code The code for the new selected language.
     * @return {undefined} void
     */
    handleChange(code) {
        const {dispatch} = this.props;

        dispatch(changeLanguage(code));
    }

    /* Render */
    render() {
        const {
            lang,
            className
        } = this.props;

        return (
            <div className={`cm-languageselect ${className}`}>
                <DropdownButton
                    title={_renderTitle(lang)}
                    onSelect={this.handleChange}
                    id="langSelect"
                >
                    {_renderMenu()}
                </DropdownButton>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.language.lang
});

export default connect(mapStateToProps)(injectIntl(LanguageSelect));



// WEBPACK FOOTER //
// ./src/containers/ui/select/LanguageSelect.jsx